export default __webpack_public_path__ + "static/media/expl-dissect_14_EN.953d00fb.png";